<style lang="scss">
  @use "../../assets/css/design-system/colors";
  @use "../../assets/css/design-system/mixins";
  @use "../../assets/css/design-system/utils";

  .date-item {
    display: flex;
    width: utils.in_rem(18.715px);
    height: utils.in_rem(18.715px);
    padding: utils.in_rem(18.715px);
    justify-content: center;
    align-items: center;
    background-color: transparent;
    border: none;
    cursor: pointer;
    @include colors.color(textBlack);
    > span {
      font-size: 12px;
      max-width: none !important;
    }
    &.swHidden {
      visibility: hidden;
    }

    &.isCurrentDate:not(.disabled, .isInRange, .isRangeStart, .isRangeEnd) {
      border: 1px dashed;
      padding: utils.in_rem(17.715px);
      border-radius: 50%;
      border-color: colors.get("interfaceSwGrey_10");
    }

    &:hover:not(.disabled, .isInRange, .isRangeStart, .isRangeEnd) {
      background-color: colors.get("interfaceTransparentBlack_4");
      border-radius: 50%;
    }

    &.notCurrentMonth {
      @include colors.color(textDisabledGrey);
    }

    &.disabled {
      cursor: not-allowed;
      @include colors.color(textDisabledGrey);
      text-decoration: line-through;
    }

    &.isInRange:not(.isRangeStart, .isRangeEnd) {
      position: relative;
      @include colors.background-color(primary_10);
      @include colors.color(textBlack);

      &:hover {
        &:not(.isRightEdge, .isLeftEdge)::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          @include colors.background-color(primary_10);
          z-index: 0;
        }

        &::before {
          content: "";
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          @include colors.background-color(interfaceTransparentBlack_4);
          z-index: 1;
        }

        > span {
          position: relative;
          z-index: 2;
        }
      }

      &.isRightEdge {
        border-top-right-radius: 20%;
        border-bottom-right-radius: 20%;
      }
      &.isLeftEdge {
        border-top-left-radius: 20%;
        border-bottom-left-radius: 20%;
      }
    }

    &.isRangeStart {
      position: relative;
      @include colors.color(textWhite);

      &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        z-index: 1;
        @include colors.background-color(primary_50);
      }

      &:hover::before {
        @include colors.background-color(primary_70);
      }

      &:not(.isRightEdge, .isSoloStart)::after {
        content: "";
        position: absolute;
        left: 50%;
        width: 50%;
        height: 100%;
        @include colors.background-color(primary_10);
        z-index: 0;
      }

      > span {
        z-index: 2;
      }
    }
    &.isRangeEnd {
      position: relative;
      @include colors.color(textWhite);

      &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        z-index: 1;
        @include colors.background-color(primary_50);
      }

      &:hover::before {
        @include colors.background-color(primary_70);
      }

      &:not(.isLeftEdge)::after {
        content: "";
        position: absolute;
        right: 50%;
        width: 50%;
        height: 100%;
        @include colors.background-color(primary_10);
        z-index: 0;
      }

      > span {
        z-index: 2;
      }
    }
    &.isSelected {
      position: relative;
      @include colors.background-color(primary_50);
      @include colors.color(textWhite);
      border-radius: 50%;
      &:hover {
        @include colors.background-color(primary_70);
      }
      > span {
        position: relative;
        z-index: 2;
      }
      &.isCurrentDate {
        @include colors.background-color(primary_50);
        @include colors.color(textWhite);
        border-radius: 50%;
        &:hover {
          @include colors.background-color(primary_70);
        }
      }
    }
  }
</style>

<script>
  //TODOs todo only add !important in extension context
  let { day, onclick = () => {}, isRange = true } = $props();
</script>

{#if isRange}
  <button
    tabindex={day.disabled ? -1 : 0}
    disabled={day.disabled}
    class="date-item"
    class:disabled={day.disabled}
    class:notCurrentMonth={day.notCurrentMonth}
    class:swHidden={day.hidden}
    class:isRangeStart={day.isRangeStart}
    class:isRangeEnd={day.isRangeEnd}
    class:isInRange={day.isInRange}
    class:isRightEdge={day.isRightEdge}
    class:isLeftEdge={day.isLeftEdge}
    class:isCurrentDate={day.isCurrentDate}
    class:isSoloStart={day.isSoloStart}
    {onclick}
  >
    <span>{day.date}</span>
  </button>
{:else}
  <button
    tabindex={day.disabled ? -1 : 0}
    disabled={day.disabled}
    class="date-item"
    class:disabled={day.disabled}
    class:notCurrentMonth={day.notCurrentMonth}
    class:swHidden={day.hidden}
    class:isCurrentDate={day.isCurrentDate}
    class:isSelected={day.isSelected}
    {onclick}
  >
    <span>{day.date}</span>
  </button>
{/if}
